/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './assets-widget.scss';

/* eslint-disable import/no-unresolved, import/default */

import assetsWidgetTemplate from './assets-widget.tpl.html';
import assetsWidgetSelectTemplate from './assets-widget-select.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.assetsWidget', [])
    .directive('agAssetsWidget', AssetsWidget)
    .name;

/*@ngInject*/
function AssetsWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            hasParentAsset: '=',
            parentAssetId: '=',
            showAeration: '=',
            fetchAssets: '&',
            fetchMapAssets: '&'
        },
        controller: AssetsWidgetController,
        controllerAs: 'vm',
        templateUrl: assetsWidgetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function AssetsWidgetController($log, $scope, agTypes, userService, siteService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.mode = 'site';

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';

    vm.selectAsset = selectAsset;
    vm.currentWidgetType = currentWidgetType;

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.hasSiteSelected = hasSiteSelected;
            vm.ctx.showSite3DView = showSite3DView;
            vm.ctx.assetBrowserWidgetTypes = agTypes.assetBrowserWidgetType;
            vm.ctx.settings.isClientMode = true;
            vm.ctx.settings.displayPagination = false;
            vm.ctx.agTypes = agTypes;
            if (vm.hasParentAsset) {
                if (!vm.ctx.assetBrowserWidgetType) {
                    vm.ctx.assetBrowserWidgetType = agTypes.assetBrowserWidgetType.map;
                }
            } else {
                var stateParams = vm.ctx.stateController.getStateParams();
                if (stateParams.assetBrowserWidgetType) {
                    vm.ctx.currentWidgetType = stateParams.assetBrowserWidgetType;
                } else {
                    vm.ctx.currentWidgetType = agTypes.assetBrowserWidgetType.map;
                }
                vm.ctx.widgetConfig.showTitle = false;
                vm.ctx.widgetTitleTemplate = assetsWidgetSelectTemplate;
                vm.mode = angular.isDefined(vm.ctx.settings.mode) ? vm.ctx.settings.mode : 'site';
                $scope.$watch('vm.ctx.currentWidgetType', function () {
                    var stateParams = vm.ctx.stateController.getStateParams();
                    stateParams.assetBrowserWidgetType = vm.ctx.currentWidgetType;
                    vm.ctx.stateController.updateState(null, stateParams, false);
                });
                $scope.$watch(function () {
                        var stateParams = vm.ctx.stateController.getStateParams();
                        return stateParams ? stateParams.assetBrowserWidgetType : null;
                    },
                    function (newBrowserType, prevBrowserType) {
                        if (newBrowserType && newBrowserType !== prevBrowserType) {
                            vm.ctx.currentWidgetType = newBrowserType;
                        }
                    }
                );

                const defaultSiteId = vm.ctx?.dashboard?.defaultSiteId;

                if (defaultSiteId && vm.mode === 'sites') {
                    vm.siteAssetsPromise = siteService.getCustomerSites(true);

                    vm.siteAssetsPromise.then(
                        function success(allSiteAssets) {

                            for (var i = 0; i < allSiteAssets.length; i++) {
                                let asset = allSiteAssets[i];

                                if (asset?.id?.id === defaultSiteId) {
                                    selectAsset(asset);
                                }
                            }
                        }
                    ).finally(() => {
                        // NOTE: We reset so the initialization and preselection is done only once on first render.
                        vm.ctx.dashboard.defaultSiteId = null;
                    });
                }
            }
        }
    });

    function currentWidgetType() {
        if (vm.ctx) {
            if (vm.hasParentAsset) {
                return vm.ctx.assetBrowserWidgetType;
            } else {
                return vm.ctx.currentWidgetType;
            }
        } else {
            return null;
        }
    }

    function showSite3DView() {
        const siteParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.site);

        if (userService.getAuthority() === 'CUSTOMER_USER') {
            return siteParams?.enable3D ?? false;
        }
        return true;
    }

    function hasSiteSelected() {
        if (vm.ctx) {
            const siteParams = vm.ctx.stateController.getStateParamsByStateId(agTypes.clientState.site);
            return siteParams != null;
        } else {
            return false;
        }
    }

    function selectAsset(asset) {
        var params = angular.copy(vm.ctx.stateController.getStateParams());
        if (!params) {
            params = {
                assetBrowserWidgetType: vm.ctx.currentWidgetType
            };
        }
        params.entityId = asset.id;
        params.entityName = asset.name;
        params.entityLabel = asset.label;
        if (asset.type === agTypes.assetType.aeration) {
            params.aerationType = asset.aerationType;
        }

        var currentStateId = vm.ctx.stateController.getStateId();
        var currentStateIndex = vm.ctx.stateController.getStateIndex();
        var parentStateIndex = currentStateIndex - 1;
        var parentStateId = vm.ctx.stateController.getStateIdAtIndex(parentStateIndex);
        if (asset.type === agTypes.assetType.site) {
            params.enable3D = asset.enable3D ?? false;
            // If Site is selected via the Map View apply view redirection logic
            if (vm.ctx.currentWidgetType === agTypes.assetBrowserWidgetType.map) {
                if (params.enable3D) {
                    params.assetBrowserWidgetType = agTypes.assetBrowserWidgetType.threeDimensional;
                }
            }

            vm.ctx.stateController.openState(agTypes.clientState.assetStates[asset.type], params, true);
        } else if (asset.type === agTypes.assetType.siloGroup) {
            if (currentStateId === agTypes.clientState.site) {
                vm.ctx.stateController.openState(agTypes.clientState.assetStates[asset.type], params, true);
            } else {
                vm.ctx.stateController.updateState(agTypes.clientState.assetStates[asset.type], params, true);
            }
        } else {
            siteService.getParentSite(asset.id).then(
                (parentSite) => {
                    var targetState;
                    if (parentSite.type === agTypes.assetType.site) {
                        targetState = agTypes.clientState.assetStates[asset.type];
                        if (currentStateId === agTypes.clientState.site) {
                            vm.ctx.stateController.openState(targetState, params, true);
                        } else if (parentStateId === agTypes.clientState.site) {
                            vm.ctx.stateController.updateState(targetState, params, true);
                        } else if (parentStateId === agTypes.clientState.siloGroup) {
                            vm.ctx.stateController.navigatePrevState(parentStateIndex);
                            vm.ctx.stateController.updateState(targetState, params, true);
                        }
                    } else if (parentSite.type === agTypes.assetType.siloGroup) {
                        targetState = agTypes.clientState.siloGroupAssetStates[asset.type];
                        if (currentStateId === agTypes.clientState.siloGroup) {
                            vm.ctx.stateController.openState(targetState, params, true);
                        } else if (parentStateId === agTypes.clientState.site) {
                            var siloGroupParams = {
                                entityId: parentSite.id,
                                entityName: parentSite.name,
                                entityLabel: parentSite.label
                            };
                            vm.ctx.stateController.updateState(agTypes.clientState.siloGroup, siloGroupParams, true);
                            vm.ctx.stateController.openState(targetState, params, true);
                        } else if (parentStateId === agTypes.clientState.siloGroup) {
                            vm.ctx.stateController.updateState(targetState, params, true);
                        }
                    }
                    vm.ctx.stateController.openRightLayout();
                },
                {}
            );
        }
    }
}
